export default __webpack_public_path__ + "static/media/buyBestBanner3.9acf75db.png";